export default __webpack_public_path__ + "static/media/cabinet1-after-1024w.2882bd2c.webp";